import React from "react";
import { get, isEmpty } from "lodash";
import { Editor } from "@sonder/editor";
import { Comment } from "@sonder/ui/source/styled/components/Comment";
import { TaskComment as TaskCommentTypes } from "core/queries/GetTaskComments";
import { DeleteCommentOptions } from "core/queries/UpdateTaskComment";
import { Attachments } from "tasks/components/TaskPanel/Attachments";

interface TaskCommentInterface {
  comment: TaskCommentTypes;
  loggedInUserId: string;
  deleteComment: (options: DeleteCommentOptions) => Promise<void>;
}

export const TaskComment = ({
  comment,
  loggedInUserId,
  deleteComment,
}: TaskCommentInterface) => {
  const commonUpdateOptions = {
    id: comment.id,
    richBody: comment.body,
    mentions: [],
  };
  return (
    <Comment
      archived={!isEmpty(comment.deletedAt)}
      authorId={get(comment, "author.id", "")}
      authorName={get(comment, "author.name", "(Unknown)")}
      avatarUrl={get(comment, "author.avatar.url")}
      createdAt={comment.createdAt}
      loggedInUserId={loggedInUserId}
      onArchive={() =>
        deleteComment({
          ...commonUpdateOptions,
          deleted: true,
        })
      }
      onUndoArchive={() =>
        deleteComment({
          ...commonUpdateOptions,
          deleted: false,
        })
      }
    >
      <Editor readOnly htmlBody={comment.richBody} plainBody={comment.body} />
      <Attachments attachments={comment.attachments} />
    </Comment>
  );
};
